import {
  IGenerateStrategyProps,
  IStrategy,
  Leg,
  ViewType,
} from "./../../../types";
import { analyzePositions } from "../../analyzeProfits";

export const generateShortStraddle = (
  params: IGenerateStrategyProps,
  strategies: IStrategy[],
  atmCallIndex: number,
  atmPutIndex: number,
  expiryDuration: number
): IStrategy[] => {
  const atmCallStrike = params.data.strikePrices[atmCallIndex];
  const atmPutStrike = params.data.strikePrices[atmPutIndex];
  const callData = params.data.data.find(
    (val) =>
      val.expiryDates === params.expiryDate && val.strikePrice === Number(atmCallStrike)
  );
  const putData = params.data.data.find(
    (val) =>
      val.expiryDates === params.expiryDate && val.strikePrice === Number(atmPutStrike)
  );

  const legs: Leg[] = [
    {
      strikePrice: atmCallStrike,
      price: callData?.CE?.lastPrice || 0,
      buy: false,
      call: true,
      quantity: -params.lotSize,
    },
    {
      strikePrice: atmPutStrike,
      price: putData?.PE?.lastPrice || 0,
      buy: false,
      call: false,
      quantity: -params.lotSize,
    },
  ];
  const analysis = analyzePositions(legs);
  const strategy: IStrategy = {
    legs: legs,
    riskRewardRatio: 1,
    maxProfit: analysis.maxProfit,
    maxLoss: Infinity,
    approxMargin: 175000,
    expiryDuration: expiryDuration,
    title: "Short Straddle " + atmCallStrike + " - " + atmPutStrike,
    maxLossROI: Infinity,
    maxProfitROI: (analysis.maxProfit * 100) / (175000),
    callBreakEven: analysis.breakEven.callBreakEven,
    putBreakEven: analysis.breakEven.putBreakEven,
    callBreakEvenPercentage:
      ((analysis.breakEven.callBreakEven - params.data.underlyingValue) /
        params.data.underlyingValue) *
      100,
    putBreakEvenPercentage:
      ((analysis.breakEven.putBreakEven - params.data.underlyingValue) /
        params.data.underlyingValue) *
      100,
    lotSize: params.lotSize,
    alert:
      "Short Straddle is a risky strategy. Max loss is much greater than max profit.",
    types: [
      ViewType["Moderately Negative"],
      ViewType["Moderately Positive"],
      ViewType.Neutral,
    ],
  };
  strategies.push(strategy);
  return strategies;
};
